import React from 'react';
import PropTypes from 'prop-types';
import { decorateUrlWithItm } from 'utils/itm';
import { useUrlLocalizer } from 'static/script/app/lang';

const MenuItemButton = ({
    containerClass,
    label,
    link,
    follow,
    itm,
    gaAttributes
}) => {
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <li className={containerClass}>
            <a
                className="btn btn-outline-dark my-4"
                href={toLocalizedUrl(
                    itm ? decorateUrlWithItm(link, itm) : link
                )}
                {...!follow && { rel: 'nofollow' }}
                {...gaAttributes}>
                {label}
            </a>
        </li>
    );
};

MenuItemButton.defaultProps = {
    className: 'site-dropdown__item-default',
    follow: true
};

MenuItemButton.propTypes = {
    notify: PropTypes.number,
    link: PropTypes.string,
    bold: PropTypes.bool,
    border: PropTypes.bool,
    label: PropTypes.node,
    gaAttributes: PropTypes.object
};

export default MenuItemButton;
